import { Children, cloneElement, FC, ReactElement, ReactNode } from 'react';
import { Button, Flex, Popover, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

interface Props {
	handleReset: () => void;
	children: ReactNode;
}

export const ResetButton: FC<Props> = ({ handleReset, children }) => {
	const [opened, controls] = useDisclosure(false);

	const reset = () => {
		handleReset();
		controls.close();
	};

	return (
		<Popover
			position="bottom"
			opened={opened}
			onChange={controls.toggle}
			width={300}
		>
			<Popover.Target>
				{cloneElement(Children.only(children as ReactElement), {
					// @ts-ignore
					onClick: controls.open,
				})}
			</Popover.Target>
			<Popover.Dropdown p="sm">
				<Text fw="bold">Wymagane potwierdzenie</Text>
				<Text size="md" mb="sm">
					Czy na pewno chcesz zresetować wszystkie pola?
				</Text>
				<Flex gap="md">
					<Button
						onClick={controls.close}
						size="sm"
						className="flex-grow-1"
						color="blue.8"
					>
						<Text fw="bold">Anuluj</Text>
					</Button>
					<Button
						variant="outline"
						color="red"
						onClick={reset}
						size="sm"
						className="flex-grow-1"
					>
						<Text fw="bold" c="red">
							Potwierdzam
						</Text>
					</Button>
				</Flex>
			</Popover.Dropdown>
		</Popover>
	);
};
